export const BLOG_SEARCH_LIMIT = 20;
